import { Injectable } from '@angular/core';
import { Area, AreaSearch } from '../../model/locations/area';
import { BaseTableService } from './base-table.service';

@Injectable({
  providedIn: 'root',
})
export class AreaTableService extends BaseTableService<AreaSearch> {
  constructor() {
    super();
  }
}
